import React from 'react';
import DebugPanel from '../../components/debug/DebugPanel';

const DebugPopoutPage: React.FC = () => (
  <div style={{ width: '100vw', height: '100vh', overflow: 'hidden' }}>
    <DebugPanel userRole="admin" />
  </div>
);

export default DebugPopoutPage;
